import { useSelector } from 'react-redux';

import { selectProductLicence } from '../../user-profiles';
import { AppState } from '../app.types';
import {
    AppDynamicParams,
    CurrentClassroom, LoadingState
} from './app.types';
import { ProductLicence } from '@api';

export function useSelectorCurrentProductId () {
    return useSelector<AppState, number>(selectCurrentProductId);
}

export function selectCurrentProductId (state: AppState) {
    return state.app.currentProductId;
}

export function useSelectorIsDefaultProduct () {
    return useSelector<AppState, boolean>(
        state => {
            const defaultProductId = state.userProfiles.data?.productLicenceContainer?.defaultProductId;

            if (typeof defaultProductId !== 'number') {
                return false;
            }

            return state.app.currentProductId === defaultProductId;
        }
    );
}

export function useSelectorCurrentClassroom () {
    return useSelector<AppState, CurrentClassroom | null>(state => {
        return state.app.currentClassroom || null;
    });
}

export function useSelectorCurrentProductLicence () {
    const productId = useSelector<AppState, number>(selectCurrentProductId);

    return useSelector<AppState, ProductLicence | null>(
        state => selectProductLicence(state, productId)
    );
}

export function useSelectorIsInitialized () {
    return useSelector<AppState, boolean>(state => {
        return state.app.isInitialized;
    });
}

export function useSelectorIsAppDataReady () {
    return useSelector<AppState, boolean>(
        state => {
            return state.app.isInitialized && state.userProfiles.isSuccess;
        }
    );
}

export function useSelectorProfileLocale () {
    return useSelector<AppState, {
        isLocaleLoaded: boolean
        locale: string | null
    }>(state => {
        return {
            isLocaleLoaded: typeof state.app.localeLoaded === 'string',
            locale: state.userProfiles.data?.country?.cultureCode || null
        };
    });
}

export function useSelectorAppLoading () {
    return useSelector<AppState, LoadingState>(state => state.app.appLoading);
}

export function useSelectorAppDynamicParams () {
    return useSelector<AppState, AppDynamicParams>(state => state.app.dynamicParams);
}

export function checkIsOneRosterActivatedSchool (state: AppState) {
    return state.userProfiles.data?.school?.isOneRosterSchoolActivated || false;
}

export function useSelectorIsOneRosterActivatedSchool () {
    return useSelector<AppState, boolean>(state => state.app.isInitialized && checkIsOneRosterActivatedSchool(state));
}
